import { useQuery } from 'react-query';

import { announcementApi } from 'src/Services/API';

const useAnnouncements = () => {
  return useQuery({
    queryKey: ['announcements'],
    queryFn: () => announcementApi.findAll(),
    staleTime: 30 * 1000,
  });
};

export default useAnnouncements;
